import { atom } from "recoil";

// export type socketStateType = string;

// export const refreshOrderState = atom<string>({
//   key: "refreshOrder",
//   default: "",
// });

export type connectType = {
  type: boolean;
  is_first: boolean;
};

export type completeOrderType = {
  date: any;
  order_status?: number;
  is_update: boolean;
};

export type newOrderType = {
  date: any;
  is_update: boolean;
  order_id: string;
};

export type notCompleteOrderType = {
  date: any;
  user_token_id: number;
  order_status: number;
  order_id: string;
  is_update: boolean;
  is_print: boolean;
};

export type updateBarogoType = {
  date: any;
  is_update: boolean;
};

export const newOrderState = atom<newOrderType>({
  key: "newOrder",
  default: {
    date: "",
    is_update: true,
    order_id: "",
  },
});

export const completeOrderState = atom<completeOrderType>({
  key: "completeOrder",
  default: {
    date: "",
    order_status: 0,
    is_update: true,
  },
});

export const notCompleteOrderState = atom<notCompleteOrderType>({
  key: "notCompleteOrder",
  default: {
    date: "",
    user_token_id: 0,
    order_status: 0,
    order_id: "",
    is_update: true,
    is_print: false,
  },
});

export const updateBarogoState = atom<updateBarogoType>({
  key: "updateBarogo",
  default: {
    date: "",
    is_update: true,
  },
});

export const refreshAppState = atom<boolean>({
  key: "refreshApp",
  default: false,
});

export const checkOrderState = atom<string>({
  key: "checkOrder",
  default: "",
});
export const assignState = atom<string>({
  key: "assign",
  default: "",
});
export const pickupState = atom<string>({
  key: "pickup",
  default: "",
});
export const deliveryState = atom<string>({
  key: "delivery",
  default: "",
});
export const loginState = atom<string>({
  key: "loginState",
  default: "",
});

export const connectState = atom<connectType>({
  key: "connectState",
  default: {
    type: false,
    is_first: true,
  },
});
